export default __webpack_public_path__ + "static/media/part_2_con1_01.f656e2ff.gif";